import styles from "./styles.module.scss";

export const Card = ({ item }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <div className={styles.label}>{item.title}</div>
        <div className={styles.icon}>
          <item.icon />
        </div>
      </div>
      <div className={styles.value} style={{ color: item.color }}>
        {item.value}
      </div>
    </div>
  );
};
